import { useEffect, useState } from "react";
import { DefaultNumericInput } from "../../../../../../common/components/default_numeric_input";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

type Props = {
  name: string;
  area: number | null | undefined;
  loading: boolean;
  saving: boolean;
  onSave: (area?: number) => void;
  onNewItem: () => void;
};

export const Header = ({ name, area, loading, saving, onSave, onNewItem }: Props) => {
  const [areaConstruida, setAreaConstruida] = useState<number | null>(area ?? null);

  useEffect(() => {
    setAreaConstruida(area ?? null);
  }, [area]);

  return (
    <div className="w-full flex flex-row justify-between gap-4">
      <div className="flex flex-row gap-4">
        <DefaultNumericInput
          name={name}
          label="Área Total Construída (m²)"
          value={areaConstruida}
          onChangeValue={setAreaConstruida}
          readOnly={loading || saving}
        />
        <div className="w-[120px]">
          <PrimaryButton disabled={loading || saving} onClick={() => onSave(areaConstruida ?? undefined)}>
            Salvar
          </PrimaryButton>
        </div>
      </div>
      <div className="w-[130px]">
        <PrimaryButton
          disabled={loading || saving}
          startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
          onClick={onNewItem}
        >
          Novo item
        </PrimaryButton>
      </div>
    </div>
  );
};
